import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  IonContent,
  IonHeader,
  IonImg,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';

import CourseList from '@/components/CourseList.vue';

import { useData } from '@/composables/data';
import { ICourse } from '@/support/models/course.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { getCoursesList } = useData();

const courses = ref<ICourse[]>([]);

const getData = async () => {
  courses.value = await getCoursesList();
};

getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonImg), {
                class: "logo",
                slot: "start",
                src: "/assets/gk-logo.svg"
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("GK Learning")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(CourseList, { courses: courses.value }, null, 8, ["courses"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})